<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5583 1.66699H13.975C12.1583 1.66699 11.2 2.62533 11.2 4.44199V6.02533C11.2 7.84199 12.1583 8.80033 13.975 8.80033H15.5583C17.375 8.80033 18.3333 7.84199 18.3333 6.02533V4.44199C18.3333 2.62533 17.375 1.66699 15.5583 1.66699Z"
      fill="#292D32"
    />
    <path
      d="M6.03341 11.1914H4.45008C2.62508 11.1914 1.66675 12.1497 1.66675 13.9664V15.5497C1.66675 17.3747 2.62508 18.3331 4.44175 18.3331H6.02508C7.84175 18.3331 8.80008 17.3747 8.80008 15.5581V13.9747C8.80842 12.1497 7.85008 11.1914 6.03341 11.1914Z"
      fill="#292D32"
    />
    <path
      d="M5.24175 8.81699C7.21617 8.81699 8.81675 7.21641 8.81675 5.24199C8.81675 3.26757 7.21617 1.66699 5.24175 1.66699C3.26733 1.66699 1.66675 3.26757 1.66675 5.24199C1.66675 7.21641 3.26733 8.81699 5.24175 8.81699Z"
      fill="#292D32"
    />
    <path
      d="M14.7583 18.3336C16.7328 18.3336 18.3334 16.733 18.3334 14.7586C18.3334 12.7842 16.7328 11.1836 14.7583 11.1836C12.7839 11.1836 11.1833 12.7842 11.1833 14.7586C11.1833 16.733 12.7839 18.3336 14.7583 18.3336Z"
      fill="#292D32"
    />
  </svg>
</template>

<script>
export default {
  name: "ExploreActiveIcon",

  data() {
    return {};
  },
  computed: {},
};
</script>